import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./model.css";
import ReactJson from "react-json-view";

export const ShowAllDetails = ({ showModal, closePopUp, data }) => {
  const myJSON = JSON.stringify(data);
  // function hasproperty(o) {
  //     if (typeof o === 'object') {
  //         for (var k in o) {
  //             if (o.hasOwnProperty(k)) {
  //                 return true;
  //             }
  //         }
  //     }

  //     return false;
  // };

  // const Showdata = (data) =>{
  //     return iterate(data)
  // }
  // var newArr = []
  // function iterate(o) {
  //     let newArr = []
  //     for (var k in o) {
  //         if (o.hasOwnProperty(k)) {
  //             if (hasproperty(o[k])) {
  //                 console.log('within ' + k);
  //                 iterate(o[k]);
  //                 console.log('exit ' + k);
  //             } else {
  //                 console.log('elseK: ' + k +  ', V:' + o[k]);
  //                 newArr.push( k +  ',' + o[k])
  //             }
  //         }
  //         console.log('newArr',newArr)
  //     }
  //     return newArr
  // };
  // console.log(Showdata(data))
  return (
    <Modal show={showModal}>
      <div class="modal-content  alerttext">
        <div class="modal-header">
          <h5 id="">Show All Details</h5>
        </div>
        <div
          class="modal-body"
          style={{
            overflowY: "scroll",
            width: "490px",
            height: "500px",
            position: "relative",
          }}
        >
          {
            <ReactJson
              src={data}
              theme={"summerfruit"}
              enableClipboard={false}
              displayDataTypes={false}
              displayObjectSize={false}
            />
          }
        </div>

        <div class="modal-footer">
          <Button variant="secondary" onClick={closePopUp} size="sm">
            Close
          </Button>
         
          
        </div>
      </div>
    </Modal>
  );
};
